import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)


import home from './home'
import newsCenter from './newsCenter'
import product from './product'
import aboutUs from './aboutUs'
export default new Vuex.Store({
    modules:{
        home,
        newsCenter,
        product,
        aboutUs

    }
})